import { useState } from "react";

export default function ForgotPassword() {
  const [account, setAccount] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);

  const handleReset = async () => {
    setError(""); setSuccess("");
    if (!account || !newPassword || !confirmPassword) { setError("请填写所有字段"); return; }
    if (newPassword !== confirmPassword) { setError("两次输入的密码不一致"); return; }
    if (newPassword.length < 6) { setError("密码长度至少 6 位"); return; }
    setLoading(true);
    try {
      const res = await fetch("/api/auth/reset-password", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ account, newPassword }) });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "重置失败"); return; }
      setSuccess("密码重置成功！即将跳转到登录页...");
      setTimeout(() => { window.location.href = "/login"; }, 2000);
    } catch { setError("网络错误，请重试"); } finally { setLoading(false); }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => { if (e.key === "Enter") handleReset(); };

  return (
    <div className="login-root">
      <div className="lg-glow1" /><div className="lg-glow2" />
      <div className="lg-card">
        <div className="lg-logo"><div className="lg-logo-icon">📈</div><div><div className="lg-logo-name">AI选股与量化交易系统</div><div className="lg-logo-sub">Quant Trading Platform</div></div></div>
        <h2 className="lg-h">重置密码</h2>
        <p className="lg-sub">输入账号和新密码进行重置</p>
        <div className="lg-field"><label className="lg-label">手机号 / 邮箱</label><input className="lg-input" type="text" placeholder="请输入注册时的手机号或邮箱" value={account} onChange={e => setAccount(e.target.value)} onKeyDown={handleKeyDown} /></div>
        <div className="lg-field"><label className="lg-label">新密码</label><div className="lg-iw"><input className="lg-input pr" type={showPwd ? "text" : "password"} placeholder="设置新密码" value={newPassword} onChange={e => setNewPassword(e.target.value)} onKeyDown={handleKeyDown} /><button className="lg-eye" type="button" onClick={() => setShowPwd(v => !v)} tabIndex={-1}>👁</button></div></div>
        <div className="lg-field"><label className="lg-label">确认密码</label><div className="lg-iw"><input className="lg-input pr" type={showConfirmPwd ? "text" : "password"} placeholder="再次输入新密码" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} onKeyDown={handleKeyDown} /><button className="lg-eye" type="button" onClick={() => setShowConfirmPwd(v => !v)} tabIndex={-1}>👁</button></div></div>
        {error && <div className="lg-err">⚠️ {error}</div>}
        {success && <div className="lg-suc">✅ {success}</div>}
        <button className="lg-btn" onClick={handleReset} disabled={loading}>{loading ? "处理中..." : "重置密码"}</button>
        <p className="lg-note"><a href="/login" style={{color:"#3b82f6",textDecoration:"none"}}>返回登录</a></p>
      </div>
    </div>
  );
}
